
const universities = [
  
];

export default universities;
